import { Component, createElement } from 'react';
import Modal from '@sasaki-dev/react-modal';
import { inject, observer } from 'mobx-react';
import DragDrop from '@sasaki-dev/react-drag-drop';

import { strip } from '../utils';
import { IHenshuApp } from '../HenshuApp';
import IHenshuPersistLayer, { IFile } from '../persist/IHenshuPersistLayer';


type EditableImageProps = {
    elem: string,
    getter: () => any,
    setter: (val: any) => void,
    app?: IHenshuApp,
    persist?: IHenshuPersistLayer,
} & React.HTMLAttributes<HTMLImageElement>;

type EditableImageState = {
    confirming: boolean;
};

const checkForProp = [
    'onClick',
    'style',
    'rel',
];


@inject('app', 'persist')
@observer
class EditableImage extends Component<EditableImageProps, EditableImageState> {

    constructor(props: EditableImageProps) {
        super(props);

        this.state = {
            confirming: false,
        };
    }

    async onLoad(file: IFile) {
        const { persist, setter } = this.props;

        if (persist) {
            setter(await persist.upload(file, 'images/'));
        }
    }

    closeModal() {
        this.setState({ confirming: false });
    }

    render() {
        const { app, elem, getter, setter } = this.props;
        const htmlProps = strip(this.props, ['elem', 'getter', 'setter', 'app', 'persist']);

        checkForProp.forEach(prop => {
            if (prop in this.props) {
                /* @ts-ignore */
                htmlProps[prop] = this.props[prop];
            }
        });

        htmlProps['src'] = getter();

        const node = htmlProps['src'] ? createElement(elem, htmlProps) : (
            <div className="Henshu__EditableImage empty">
                <em>...</em>
            </div>
        );

        return app && !app.isEditing ? node : (
            <div className="Henshu__EditableImage">
                {node}

                <DragDrop onLoad={this.onLoad.bind(this)} />

                {htmlProps['src'] && <button onClick={() => this.setState({ confirming: true })}>Remove</button>}

                {this.state.confirming && (
                    <Modal className="Henshu__Modal" onClose={() => this.closeModal()}>
                        <p>
                            Are you sure you want to remove this image?
                        </p>

                        <div className="Henshu__Modal-buttons">
                            <button onClick={() => this.closeModal()}>Cancel</button>
                            <button onClick={() => { setter(''); this.closeModal()}}>Remove Image</button>
                        </div>
                    </Modal>
                )}
            </div>
        )
    }
}
export default EditableImage;


const ImageElements = [
    'img'
];
export { ImageElements };
